import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetCustomerDetails = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`resources/customers/${customerId}`, { hideError: true }),
  });
